'use client';
import { GREY_400 } from '@mnd-frontend/ui/shared/tokens';
import { ticks } from 'd3-array';
import { axisBottom, axisLeft } from 'd3-axis';
import { select } from 'd3-selection';
import { memo, useEffect, useRef } from 'react';
import styled from 'styled-components';

const GridStyle = styled.g`
  line {
    stroke: ${GREY_400};
    stroke-dasharray: 4;
  }
`;

interface Props {
  scaleX: any;
  scaleY: any;
}

const Grid = memo(({ scaleX, scaleY }: Props) => {
  const ref = useRef(null);
  const [x0, x1] = scaleX.range();

  useEffect(() => {
    const axis = axisLeft(scaleY)
      .tickPadding(0)
      .tickSize(x0 - x1)
      .tickValues((ticks as any)(...scaleY.domain(), scaleY.tickCount).slice(1))
      .tickFormat('' as any);
    select(ref.current)
      .call(axis as any)
      .call(g => g.select('.domain').remove())
      .attr('stroke-dasharray', '4,4');
  });

  return <GridStyle ref={ref} transform={`translate(${x0}, 0)`} />;
}) as any;

Grid.Horizontal = memo(({ scaleX, scaleY }: Props) => {
  const ref = useRef(null);
  const [y1, y0] = scaleY.range();

  useEffect(() => {
    const axis = axisBottom(scaleX)
      .tickPadding(0)
      .tickSize(y0 - y1)
      .tickValues((ticks as any)(...scaleX.domain(), scaleX.tickCount).slice(1))
      .tickFormat('' as any);
    select(ref.current)
      .call(axis as any)
      .call(g => g.select('.domain').remove())
      .attr('stroke-dasharray', '4,4');
  });

  return <GridStyle ref={ref} transform="translate(0, 0)" />;
});

export default Grid;
